export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/sign-up',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  WORKSPACE: '/workspace',
  USER_ROLE_MANAGEMENT: '/user-role-management',
  PARTNER: '/partner',
};
